import Event from '../../core/Event';

export default class RemoveCustomerConfirmed extends Event {
    public static type = 'RemoveCustomerConfirmed';

    constructor(public readonly customerId: string) {
        super(RemoveCustomerConfirmed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/RemoveCustomerConfirmed.ts